/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { getIEVersion } from './helper.mjs';
import '../../../_chunks/dep-be6b014c.mjs';
import '../../../_chunks/dep-558fadc3.mjs';
import '../../../_chunks/dep-b9505f3d.mjs';
import '../../../_chunks/dep-1ec078b3.mjs';
import '../../../_chunks/dep-fa22eda7.mjs';
import '../../../_chunks/dep-8a0ff305.mjs';
import '../../../_chunks/dep-b390ff23.mjs';
import '../../../_chunks/dep-34428f12.mjs';
import '../../../_chunks/dep-1c40d002.mjs';
import '../../../_chunks/dep-e9ff4ce8.mjs';
import '../../../_chunks/dep-c54c9f32.mjs';
import '../../../_chunks/dep-61150968.mjs';
import '../../../_chunks/dep-51567b45.mjs';
import '../../../_chunks/dep-9a7888c7.mjs';
import '../../../_chunks/dep-af8c0169.mjs';

function getScrollbarWidthWithCSS() {
  var defaultScrollbarWidth = 6;
  if (typeof navigator === "undefined" || !navigator) return defaultScrollbarWidth;
  if (/(Chrome|Safari)/i.test(navigator.userAgent)) return defaultScrollbarWidth;
  var scrollDiv = document.createElement("div");
  scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  if (/Firefox/.test(navigator.userAgent)) {
    scrollbarWidth -= 4;
  }
  if (getIEVersion() <= 11) {
    scrollbarWidth = 12;
  }
  return scrollbarWidth;
}
function getScrollbarWidth() {
  var scrollDiv = document.createElement("div");
  scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

export { getScrollbarWidth, getScrollbarWidthWithCSS };
//# sourceMappingURL=getScrollbarWidth.mjs.map
